// 9fbef606107a605d69c0edbcd8029e5d
import { EXTRA_POINTS_REDUCER_KEY } from '@tcp/core/src/constants/reducer.constants';
import { getDynamicLabelValues } from '../../../../../utils/labels/labelUtilty';

export const getExtraPointsTilesContentId = () => {
  let extraPointsTilesContentIds = [];
  const referredLabels = getDynamicLabelValues('account.earnExtraPoints.referred');
  if (referredLabels && Array.isArray(referredLabels)) {
    // TODO: get contentID based on name once referred object key as "name" is configured
    extraPointsTilesContentIds = referredLabels[0].contentId;
  }
  return extraPointsTilesContentIds;
};

export const getPromoListDetails = (state) => {
  return state[EXTRA_POINTS_REDUCER_KEY]?.get('promoListDetails');
};

export const getPromoListDetailsFetchingState = (state) => {
  return state[EXTRA_POINTS_REDUCER_KEY]?.get('isFetching');
};
